import { GetInAppPromotionResponse } from "@performyard/service-contracts";

import request from "./internal-base-request";

export type InAppPromotionResponse = Omit<GetInAppPromotionResponse, "_id"> & { _id: string };

/**
 * Get the current specific in-app promotion for the company
 * @param promotionId The key identifying the promotion is the promotionId.
 * @returns Response is an object with the promotion details
 */

export const getInAppPromotion = async (promotionId: string) => {
	const [response] = await request<InAppPromotionResponse>(`/v1/in-app-promotions/${promotionId}`);

	return response;
};
